import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';
import { Box } from '@fiverr-private/theme';
import { TableProps } from '../../types';
import { TableFilterGroup } from './components/TableFilterGroup';
import { TableHeading } from './components/TableHeading';
import { TableBody } from './components/TableBody';

export const Table = <T,>({
  table,
  emptyPage,
  noResults,
  hideResultTitle,
  onRowImpression,
  onRowClick,
  totalCount,
}: TableProps<T>) => {
  const rows = table.getCoreRowModel()?.rows;

  return (
    <Container>
      {!!rows?.length && <TableFilterGroup table={table} />}
      {!!totalCount && !hideResultTitle && (
        <Text size="b_xs" paddingBottom="2">
          <I18n k="briefs_table.total_count" params={{ count: totalCount }} />
        </Text>
      )}
      <Container borderRadius="sm" borderWidth="sm">
        <Box as="table" width="100%" boxSizing="borderBox">
          <TableHeading table={table} />
          <TableBody
            onRowClick={onRowClick}
            onRowImpression={onRowImpression}
            table={table}
            emptyPage={emptyPage}
            noResults={noResults}
          />
        </Box>
      </Container>
    </Container>
  );
};
